module.exports = __webpack_public_path__ + "img/flexible-character.40220ba0.png";